export default __webpack_public_path__ + "static/media/Person2.e0f622e5.jpeg";